import { RUN_LOGOUT, RUN_LOGIN, RUN_STATE_LOAD, SET_INFO, SET_STATE, GET_TOKEN, RUN_FORGOT_PASSWORD, RUN_RESET_PASSWORD_FROM_HASH, RUN_CHANGE_PASSWORD, RUN_USER_SIGNUP,RUN_USER_LOGIN_2FA,RUN_REGISTER_STEP1,RUN_REGISTER_STEP2,RUN_REGISTER_STEP3,RUN_GET_USER_REGISTERATION_STEP_DATA,RUN_REGISTER_OPTIONS,GET_REGISTER_OPTIONS,SET_REGISTER_OPTIONS } from '../types'
import * as RxFactory from './api/rx-factory'
import * as Enpoints from './api/endpoints'
import * as COMMON from './commomFunction'
import * as types from '@/types'
export const actions = {
    [RUN_LOGIN]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_LOGIN, credentials, '', commit, (error, result) => {
            if (!error) {
                result.res_data.user.loggedIn = true
                commit(SET_STATE, result.res_data.user)
                localStorage.setItem('user', btoa(JSON.stringify(result.res_data.user)))
                credentials.localParams.parameter.$router.replace('/get-started')
                COMMON._messageDisplayFunction(credentials.localParams.parameter, 'login successfully', 'success')
            } else {
                // COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
                credentials.localParams.parameter.loginError = result.res_data
            }
        })
    },
    [RUN_STATE_LOAD]({ commit, state, getters, dispatch }, credentials) {
        const data = {}
        let user = localStorage.getItem('user')
        if (user) {
            user = atob(user)
            user = JSON.parse(user)
        }
        commit(SET_STATE, user)
        if (user !== null && user !== '') {
            COMMON._executeApi(Enpoints.EP_FRESH_DATA, credentials, { 'Authorization': 'Bearer ' + getters[GET_TOKEN] }, commit, (error, result) => {
                if (!error) {
                    result.res_data.user.loggedIn = true
                    commit(SET_STATE, result.res_data.user)
                    localStorage.setItem('user', btoa(JSON.stringify(result.res_data.user)))
                } else {
                    COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
                }
            })
        }
    },
    [RUN_LOGOUT]({ commit, state, getters, dispatch }, credentials) {
        RxFactory.get(Enpoints.BASE_URL + Enpoints.EP_LOGOUT, {'Authorization': 'Bearer ' + getters[GET_TOKEN]})
        .map(response => response.data)
        .subscribe(data => {
                COMMON._handleLogout(data, commit, { router: credentials.localParams.parameter.$router, forward: true })
            },
            (e, d, s) => {
                COMMON._handleLogout(e, commit, {router: credentials.localParams.parameter.$router, forward:true})
            }
        )
    },
    [RUN_USER_SIGNUP]({commit, state, dispatch,getters}, credentials){
        COMMON._executeApi(Enpoints.EP_USER_SIGNUP, credentials,'',commit, (error, result)=>{
            if(!error){
                // if(credentials.localParams.page){
                //     credentials.localParams.parameter.insertId = result.res_data.insertId
                //      COMMON._messageDisplayFunction(credentials.localParams.parameter,'OTP resend successfully','success')
                // }else{
                //     credentials.localParams.parameter.insertId = result.res_data.insertId
                // }
                COMMON._messageDisplayFunction(credentials.localParams.parameter,'SignUp successfully','success')
                result.res_data.user.loggedIn = true
                commit(SET_STATE, result.res_data.user)
                localStorage.setItem('user', btoa(JSON.stringify(result.res_data.user)))
                credentials.localParams.parameter.$router.replace('/get-started')
            }else{
                COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
            }
        })
    },
    [RUN_FORGOT_PASSWORD]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_FORGOT_PASSWORD, credentials, '', commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.resend = true
                COMMON._messageDisplayFunction(credentials.localParams.parameter, 'A link for change password has been sent on your registered email id', 'success')
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [RUN_RESET_PASSWORD_FROM_HASH]({ commit, state, dispatch, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_RESET_PASSWORD_FROM_HASH, credentials, '', commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.displayMessage = true
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, "Sorry! This link has been exipred. Click <router-link :to='/forgot-password'>Here</router-link> to reset again!", 'error')
            }
        })
    },
    [RUN_CHANGE_PASSWORD]({ commit, state, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_CHANGE_PASSWORD, credentials, { 'Authorization': 'Bearer ' + getters[GET_TOKEN] }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.reset()
                credentials.localParams.parameter.logout()
                COMMON._messageDisplayFunction(credentials.localParams.parameter, 'password changed successfully', 'success')
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [RUN_REGISTER_OPTIONS]({ commit, state, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_REGISTER_OPTIONS, credentials, { 'Authorization': 'Bearer ' + getters[GET_TOKEN] }, commit, (error, result) => {
            if (!error) {
                commit(SET_REGISTER_OPTIONS, result.res_data)
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [RUN_REGISTER_STEP1]({commit, state, dispatch,getters}, credentials){
        COMMON._executeApi(Enpoints.EP_REGISTER_STEP1, credentials,{'Authorization': 'Bearer ' + getters[GET_TOKEN]},commit, (error, result)=>{
            if(!error){
                let user_json = getters['GET_USER']
                user_json.step = 1
                /*user_json.username = credentials.globalParams.fname +' '+ credentials.globalParams.mname +' '+ credentials.globalParams.lname
                user_json.profile.firstname = credentials.globalParams.fname 
                user_json.profile.middlename = credentials.globalParams.mname 
                user_json.profile.lastname = credentials.globalParams.lname*/
                commit(SET_STATE, user_json)

                var user = localStorage.getItem('user')
                user = atob(user)   ;   user = JSON.parse(user)
                user.step = 1                                   
                localStorage.setItem('user', btoa(JSON.stringify(user)))
                credentials.localParams.parameter.$router.replace('/step2')
            }else{
                 COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
            }
        }) 
    },
    [RUN_REGISTER_STEP2]({commit, state, dispatch,getters}, credentials){
        COMMON._executeApi(Enpoints.EP_REGISTER_STEP2, credentials,{'Authorization': 'Bearer ' + getters[GET_TOKEN]},commit, (error, result)=>{
            if(!error){
                let user_json = getters['GET_USER']
                user_json.step = 2
                commit(SET_STATE, user_json)

                var user = localStorage.getItem('user')
                user = atob(user)   ;   user = JSON.parse(user)
                user.step = 2                                   
                localStorage.setItem('user', btoa(JSON.stringify(user)))
                credentials.localParams.parameter.$router.replace('/step3')
            }else{
                 COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
            }
        })
    },
    [RUN_REGISTER_STEP3]({commit, state, dispatch,getters}, credentials){
        COMMON._executeApi(Enpoints.EP_REGISTER_STEP3, credentials,{'Authorization': 'Bearer ' + getters[GET_TOKEN]},commit, (error, result)=>{
            if(!error){
                let user_json = getters['GET_USER']
                user_json.step = 3
                commit(SET_STATE, user_json)

                var user = localStorage.getItem('user')
                user = atob(user)   ;   user = JSON.parse(user)
                user.step = 3                                   
                localStorage.setItem('user', btoa(JSON.stringify(user)))
                credentials.localParams.parameter.$router.replace('/get-started')
            }else{
                 COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
            }
        })
    },
    [RUN_GET_USER_REGISTERATION_STEP_DATA]({commit, state, dispatch,getters}, credentials){
        let user_info = getters['GET_USER']
        const _that = credentials.localParams.parameter
        // if(parseInt(user_info.step) >= 2){
        //     _that.disable = true
        // }
        // if((parseInt(credentials.localParams.step) <= parseInt(user_info.step)) || (parseInt(credentials.localParams.step) == parseInt(user_info.step)+1)){}else{
        //     let stepData = (parseInt(user_info.step) == 0)? '/step1' : '/step'+user_info.step
        //     _that.$router.replace(stepData)
        // }
        COMMON._executeApi(Enpoints.EP_GET_USER_REGISTERATION_STEP_DATA, credentials,{'Authorization': 'Bearer ' + getters[GET_TOKEN]},commit, (error, result)=>{
            if(!error){
                if(result.res_data.length > 0){
                    switch(parseInt(credentials.localParams.step)){
                        case 1:
                            if(parseInt(result.res_data[0].membership_id) == 1){
                                _that.membership = result.res_data[0].membership_id
                                _that.member_type = ''
                            }else{
                                _that.membership = 2
                                _that.member_type = result.res_data[0].membership_id
                            }
                        break;
                        case 2:
                           _that.mode = result.res_data[0].payment_method_id
                        break;
                        case 3:
                            _that.timing = result.res_data[0].slot_timings_id
                        break;
                    }
                }
            }
            else{
                COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
            }
        })
    },
}


// WEBPACK FOOTER //
// ./src/store/actions.js